import AccordionSection from '@app/components/common/Accordion/AccordionSection';
import Grid from '@app/components/common/Grid';
import { ItemPrepStationSectionKind } from '@app/hocs/types';
import { FormMode } from '@westondev/tableturn-core';
import PrinterLocationsSection from '../PrinterLocationsSection';
import { IAccordionSection } from '@app/components/common/Accordion/AccordionSection/types';
import { WithTranslation } from 'react-i18next';
import { selectIsMenuCreationMode } from '@app/state/menu/menuSelectors';
import { useSelector } from 'react-redux';

const PrepStationsSection = ({
  t,
  ...accordionSectionProps
}: IAccordionSection & WithTranslation) => {
  const isMassUpdate = false;
  const isCreation = useSelector(selectIsMenuCreationMode);

  const mode = isCreation
    ? FormMode.CREATE
    : isMassUpdate
    ? FormMode.MASS_UPDATE
    : FormMode.UPDATE;
  return (
    <AccordionSection
      title={t('menuScreen.itemDetails.prepStationsSection.title')}
      info={t(
        'menuScreen.itemDetails.prepStationsSection.prepStations.toolTip',
      )}
      {...accordionSectionProps}>
      <Grid rowGap={20}>
        <Grid.Item>
          <PrinterLocationsSection
            mode={mode}
            kind={ItemPrepStationSectionKind.ADD}
          />
        </Grid.Item>
        {isMassUpdate && (
          <Grid.Item>
            <PrinterLocationsSection
              mode={mode}
              kind={ItemPrepStationSectionKind.REMOVE}
            />
          </Grid.Item>
        )}
      </Grid>
    </AccordionSection>
  );
};
export default PrepStationsSection;
